<script setup lang="ts">
import {Compass, Lightbulb, Target, Trophy} from 'lucide-vue-next';
import SectionHeading from '../components/SectionHeading.vue';
import {useLanguage} from '../composables/useLanguage';

const {isArabic} = useLanguage();

const pillars = [
  {
    icon: Target,
    titleAr: 'رؤيتنا',
    titleEn: 'Our vision',
    textAr: 'أن نكون من الأسماء الأكثر ثقة في المقاولات والاستثمار العقاري داخل ليبيا.',
    textEn: 'To be one of the most trusted names in contracting and real estate investment in Libya.',
  },
  {
    icon: Lightbulb,
    titleAr: 'مهمتنا',
    titleEn: 'Our mission',
    textAr: 'تنفيذ مشاريع تحقق قيمة حقيقية للعملاء وتجمع بين الجودة والانضباط والوضوح.',
    textEn: 'Deliver projects that create real value for clients through quality, discipline, and clarity.',
  },
  {
    icon: Compass,
    titleAr: 'مبادئنا',
    titleEn: 'Our principles',
    textAr: 'السلامة، والشفافية، والالتزام، والتحسين المستمر في كل ما نقوم به.',
    textEn: 'Safety, transparency, accountability, and continuous improvement in everything we do.',
  },
];
</script>

<template>
  <section class="page-shell">
    <div class="container page-hero">
      <SectionHeading
        align="start"
        :eyebrow="isArabic ? 'رؤيتنا' : 'Company vision'"
        :title="isArabic ? 'نبني قيمة تدوم بعد انتهاء المشروع' : 'We build value that lasts beyond the project'"
        :description="isArabic
          ? 'ننظر إلى كل مشروع كفرصة لترك أثر مهني واقتصادي واضح ومستدام.'
          : 'We see every project as a chance to leave a clear, lasting professional and economic impact.'"
      />
    </div>
    <div class="container page-grid page-grid--cards">
      <article v-for="pillar in pillars" :key="pillar.titleEn" class="page-card reveal">
        <span class="page-card__icon"><component :is="pillar.icon" :size="28" /></span>
        <h3>{{ isArabic ? pillar.titleAr : pillar.titleEn }}</h3>
        <p>{{ isArabic ? pillar.textAr : pillar.textEn }}</p>
      </article>
    </div>
    <div class="container page-banner reveal">
      <Trophy :size="28" />
      <p>{{ isArabic ? 'نهدف إلى تنفيذ أعمال تضيف ثقة وقيمة وجمالاً للمجتمع الذي نخدمه.' : 'We aim to deliver work that adds trust, value, and quality to the communities we serve.' }}</p>
    </div>
  </section>
</template>
